module.exports = __webpack_public_path__ + "static/media/cook.b6a08aaa.png";